import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from '@mui/icons-material';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'CR',
    quote: 'Me bloqueó en todos lados. Hice el protocolo igual. A los 4 días me desbloqueó sin que yo hiciera nada. Al día 7 me pidió hablar. Lloré de emoción.',
    name: 'Carolina R.',
    city: 'Mendoza',
    product: 'El Protocolo del Retorno + Sello de Oro'
  }, {
    initials: 'RM',
    quote: 'El Kit de Mensajes fue lo que me salvó cuando me escribió. Antes hubiera dicho cualquier cosa desde la ansiedad. Esta vez respondí con calma y él siguió escribiendo toda la noche.',
    name: 'Romina M.',
    city: 'Buenos Aires',
    product: 'El Protocolo del Retorno'
  }, {
    initials: 'PA',
    quote: 'Volvimos pero seguíamos peleando igual. Con el Sello de Oro hice el ritual de comunicación y en 3 semanas las discusiones bajaron un 80%. Algo cambió en mí y él lo sintió.',
    name: 'Paula A.',
    city: 'Neuquén',
    product: 'El Protocolo del Retorno + Sello de Oro'
  }, {
    initials: 'VG',
    quote: 'Hice el Ritual de las 7 Generaciones llorando porque entendí que mi mamá, mi abuela y yo teníamos el mismo patrón. Desde ese día algo se acomodó en mí y en la relación.',
    name: 'Valentina G.',
    city: 'Rosario',
    product: 'Sello de Oro'
  }];
  return <section className="py-16 px-4 bg-miel-darker relative" data-id="element-332">
      <div className="max-w-6xl mx-auto" data-id="element-333">
        <FadeIn data-id="element-334">
          <div className="text-center mb-10" data-id="element-335">
            <h2 className="font-playfair text-3xl md:text-4xl text-miel-cream mb-4" data-id="element-336">
              Más historias de{' '}
              <span className="text-miel-crimson italic" data-id="element-337">
                retornos exitosos
              </span>
            </h2>
            <div className="flex justify-center gap-1 text-miel-gold" data-id="element-338">
              {[...Array(5)].map((_, i) => <Star key={i} data-id="element-339" />)}
            </div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-340">
          {testimonials.map((testimonial, i) => <FadeIn key={i} delay={0.1 * i} direction={i % 2 === 0 ? 'right' : 'left'} data-id="element-341">
              <div className="bg-miel-dark border border-miel-crimson/20 p-8 rounded-2xl h-full flex flex-col relative overflow-hidden" data-id="element-342">
                {/* Decorative quote mark */}
                <div className="absolute top-4 right-6 text-6xl font-playfair text-miel-crimson/10 leading-none" data-id="element-343">
                  "
                </div>

                <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-344">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-miel-crimson to-miel-red flex items-center justify-center font-playfair font-bold text-miel-cream text-lg shadow-lg" data-id="element-345">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-346">
                    <div className="flex text-miel-gold mb-1" data-id="element-347">
                      {[...Array(5)].map((_, j) => <Star key={j} fontSize="small" data-id="element-348" />)}
                    </div>
                    <div className="text-xs text-miel-goldLight/80 bg-miel-gold/10 px-2 py-0.5 rounded border border-miel-gold/20 inline-block" data-id="element-349">
                      {testimonial.product}
                    </div>
                  </div>
                </div>

                <p className="text-miel-cream/90 italic mb-6 flex-grow text-lg relative z-10" data-id="element-350">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto pt-4 border-t border-miel-crimson/10 relative z-10" data-id="element-351">
                  <p className="text-miel-goldLight font-semibold" data-id="element-352">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-miel-cream/50" data-id="element-353">
                    {testimonial.city}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}